// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"158":"80c82978","298":"56c51221","379":"e0752004","580":"0c8dff8d","780":"e304d344","828":"caa3c9ef"}[chunkId] + ".chunk.css";
};